const FREE_EMAIL_DOMAINS = new Set([
  "gmail.com",
  "yahoo.com",
  "hotmail.com",
  "outlook.com",
  "icloud.com",
  "proton.me",
  "protonmail.com",
  "rediffmail.com"
]);

export const isFreeEmailProvider = (
  email
) => {
  if (!email) return false;

  const domain = email
    .split("@")[1]
    ?.toLowerCase();

  return FREE_EMAIL_DOMAINS.has(
    domain
  );
};